/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskBusinessName } from './ExecRiskBusinessName';
import {
    ExecRiskBusinessNameFromJSON,
    ExecRiskBusinessNameFromJSONTyped,
    ExecRiskBusinessNameToJSON,
} from './ExecRiskBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskContractor
 */
export interface ExecRiskContractor {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskContractor
     */
    person_name?: string;
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskContractor
     */
    business_name?: ExecRiskBusinessName;
}

/**
 * Check if a given object implements the ExecRiskContractor interface.
 */
export function instanceOfExecRiskContractor(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskContractorFromJSON(json: any): ExecRiskContractor {
    return ExecRiskContractorFromJSONTyped(json, false);
}

export function ExecRiskContractorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskContractor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person_name': !exists(json, 'person_name') ? undefined : json['person_name'],
        'business_name': !exists(json, 'business_name') ? undefined : ExecRiskBusinessNameFromJSON(json['business_name']),
    };
}

export function ExecRiskContractorToJSON(value?: ExecRiskContractor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person_name': value.person_name,
        'business_name': ExecRiskBusinessNameToJSON(value.business_name),
    };
}

